export enum ReceivedMailState {
  RECEIVED = 'received',
  CODE_CHECK = 'code_check',
  NOT_RECEIVED = 'not-received',
  NO_MORE_RETRIES = 'no-more-retries',
  VERIFIED = 'verified',
  ERROR = 'error',
  UNSUBSCRIBED = 'unsub',
  SOFT_BOUNCE = 'soft-bounce',
}

export enum MailOtpSource {
  Affiliate = 'affiliate',
  Account = 'account',
}

export const MAIL_OTP_MAX_RETRIES = 3;

export enum FailedMailOtpCodeReason {
  INVALID_CODE = 'invalid-code',
  EXPIRED_CODE = 'expired-code',
  ALREADY_USED = 'already-used',
}

export type sendMailReturnType = {
  sent: boolean;
  reason?: ReceivedMailState;
};
